import React from 'react';
import styles from './Profilecard.module.scss';


// eslint-disable-next-line react/prop-types
function ProfleCard({ src, name}) {
  return (
      <figure className={styles.myProfilePic}>
        <img alt="mypic" src={src}  className={styles.profilePic}/>
        <h4 className={styles.profileName}>{name}</h4>
      </figure>
  )
}

export default ProfleCard